<template>
  <Permissioned vertical class="my-5">
    <div
      class="mx-2"
      v-for="(item, index) in navigationItems"
      :key="index"
      :permission="item.permission"
    >
      <v-card
        :key="index"
        rounded
        class="with-shadow mb-5 pa-5"
        :to="to(item)"
        :href="item.isExternalLink && getTargetRoute(item)"
      >
        <div class="d-flex flex-row">
          <v-icon color="primary" size="1.5rem" class="mr-3">
            mdi-{{ item.icon }}
          </v-icon>
          <div>
            <div class="font-weight-bold">{{ item.title }}</div>
            <span class="secondary-text"> {{ item.description }} </span>
          </div>
        </div>
      </v-card>
    </div>
  </Permissioned>
</template>

<script>
import { MAIN_NAVIGATION_ITEMS } from "@/constants/navigation";
import Permissioned from "@/components/common/Permissioned";
import { filter } from "lodash";

export default {
  components: { Permissioned },
  data() {
    return {
      navigationItems: filter(
        MAIN_NAVIGATION_ITEMS,
        ({ routeName }) => routeName !== "dashboard"
      )
    };
  },
  methods: {
    getTargetRoute(item) {
      const API_URL = process.env.VUE_APP_API_URL;
      return item.isExternalLink
        ? `${API_URL}/2/${item.routeName}`
        : `/${item.routeName}`;
    },
    to(item) {
      return item.isExternalLink ? null : this.getTargetRoute(item);
    }
  }
};
</script>
